export default __webpack_public_path__ + "static/media/gallery_06.db1b9053.jpg";